import $ from 'jquery';
import slick from 'slick-carousel';

export default function () {
	//banner slider
        var carousel = $('.js-homesider');

        if(carousel){
                carousel.slick({
                infinite: true,
                rows: 0,
                arrows: false,
                dots: true,
                fade: true,
                cssEase: 'linear',
                speed: 3000,
                focusOnSelect: true,
                // autoplay: true,
                // autoplaySpeed: 3000,
        });

}
}
